import { z } from 'zod';

import { Payment } from '../loan/Payments';
import { BaseLoanEvent } from './BaseLoanEvent';
import { NachaPaymentInfo } from './NachaPaymentInfo';

export const CreatePaymentEvent = BaseLoanEvent.extend({
  type: z.literal('createPayment'),
  payment: Payment,
  disableEmail: z.boolean().optional(),
  nachaPayment: NachaPaymentInfo.optional(),
});
export type CreatePaymentEvent = z.infer<typeof CreatePaymentEvent>;
